module.exports = __webpack_public_path__ + "static/industrial-e49f7a8d39a07de35cda7efab074fa01.png";